export const VENUES_CARD_VIDEO_SET_ACTIVE = 'VENUES_CARD_VIDEO_SET_ACTIVE';
